import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNicotine = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:#24a81b;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}" }) }),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(5 5)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M7,13v6.667",
					transform: "translate(-0.333 3.667)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M21,13v6.667",
					transform: "translate(9 3.667)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M16,4c0,5,3.333,5,3.333,10",
					transform: "translate(5.667 -2.333)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M3.335,19.667h18V13H5.653",
					transform: "translate(3.667 3.667)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M19,3c0,5,3.333,5,3.333,10",
					transform: "translate(7.667 -3)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M17.667,19.667H3V13H15",
					transform: "translate(-3 3.667)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H40V40H0Z"
		})
	]
});
export default SvgNicotine;
